export const SANR_DISCORD = 'https://discord.gg/YtqHEYEYTF';
export const SANR_DEBANK = 'https://debank.com/profile/0x25179E1A126077f54552781494D81cec50b393c8';
export const SANR_TELEGRAM = 'https://t.me/sanr_protocol';
export const SANR_TWITTER = 'https://twitter.com/Sanr_App';
export const SANR_FARCASTER = 'https://warpcast.com/sanr';
export const SANR_LENS = 'https://hey.xyz/u/sanr_app';
export const SANR_BLOG = 'https://medium.com/sanrl2';
